export default __webpack_public_path__ + "static/media/15.db5e231f.jpg";